import InGameCurrency from '~/client/features/InGameCurrency';
import useCurrencyConfig from '~/client/hooks/currency/useCurrencyConfig';
import useFeature from '~/client/hooks/feature/useFeature';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useSite from '~/client/hooks/useSite';
import DepositLink from '~/client/shared/NavBarControls/LoggedInControls/UserControls/DepositLink';
import QuickDepositButton from './QuickDepositButton';
import useListGateway from './QuickDepositButton/hook/useListGateway';

const UserFooter: FC = () => {
  const {
    isQuickDepositVisible,
    isDepositAgainVisible,
    isSbio,
    depositAgainCashierPath,
    isDepositAgainWithFiat,
  } = useUserFooter();

  if (isDepositAgainWithFiat && !isSbio && isDepositAgainVisible) {
    return (
      <div className="grid grid-flow-col gap-4">
        <DepositLink cashierPath={depositAgainCashierPath} isDepositAgain />
        <InGameCurrency module="game" />
      </div>
    );
  }

  return (
    <div className="grid grid-flow-col gap-4">
      {isQuickDepositVisible && !isSbio && <QuickDepositButton />}
      {!isSbio && <InGameCurrency module="game" />}
    </div>
  );
};

const useUserFooter = () => {
  const currencyConfig = useCurrencyConfig();
  const isLoggedIn = useIsLoggedIn();
  const { isSbio } = useSite();
  const isDepositAgainWithFiat = useFeature('isDepositAgainWithFiat');
  const isCoin = currencyConfig?.type === 'coin';
  const isFiat = currencyConfig?.type === 'fiat';

  const isQuickDepositVisible = isCoin && isLoggedIn;
  const { urlAlias, amount } = useListGateway({ currencyConfig });

  const isDepositAgainInfoAvailable = urlAlias && amount;
  const isDepositAgainVisible =
    isDepositAgainInfoAvailable && isFiat && isLoggedIn;
  const depositAgainCashierPath = `${urlAlias}-${amount}`;

  return {
    isQuickDepositVisible,
    isDepositAgainVisible,
    isDepositAgainWithFiat,
    isSbio,
    isCoin,
    depositAgainCashierPath,
  };
};

export default UserFooter;
